<template>
	<template v-if="authorized">
		<slot></slot>
	</template>
	<div
		v-else-if="show403 && isSuccess"
		class="flex h-full w-full flex-col items-center justify-center gap-4"
	>
		<div class="text-3xl">
			<span class="font-bold text-branding-700">403</span> - Unauthorized
		</div>
		<div class="max-w-[40rem] px-4 text-center italic text-slate-700">
			You do not have access to this page. If you believe you should have
			permission, please contact your administrator.
		</div>
		<ion-button size="small" @click="router.back">Go Back</ion-button>
	</div>
</template>

<script setup lang="ts">
	import { PermissionKey } from "seedgreen-shared/dtos/PermissionTypeDTO";
	import { useMyUser } from "seedgreen-shared/queries/user";
	import { computed } from "vue";
	import { IonButton, useIonRouter } from "@ionic/vue";

	interface Props {
		permissions: PermissionKey[];
		require?: "any" | "all";
		show403?: boolean;
		requireAdmin?: boolean; // if true, only admins are authorized
	}
	const props = withDefaults(defineProps<Props>(), {
		require: "any",
		show403: false,
		requireAdmin: false,
	});

	const { myUser, isSuccess } = useMyUser();

	const router = useIonRouter();

	const authorized = computed(() => {
		if (!myUser.value) return false;

		// If explicitly requiring admin, only admins pass
		if (props.requireAdmin) {
			return myUser.value.admin === true;
		}

		if (props.require === "any") {
			return myUser.value.hasAnyPermission(...props.permissions);
		} else {
			return myUser.value.hasAllPermissions(...props.permissions);
		}
	});
</script>
